module.exports = __webpack_public_path__ + "img/flood_sensor.204add79.svg";